import TextArea from 'antd/es/input/TextArea'
import React from 'react'

const Debriefing = () => {
  return (
    <div className='row'>
      <div className='col-md-12'>
        <div className='card card-cs'>
          <div className='card-body '>
            <label className='input-label'>Pursuit Decision Notes</label>
            <TextArea className='bg-light-red' ></TextArea>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Debriefing